// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html:root {
  --toastify-text-color-light: #595958;
}
body {
  word-break: break-word;
}
.icon-wrapper {
  width: 20px;
  height: 20px;
}

.w-20 {
  width: 20px;
}

.w-24 {
  width: 24px;
}

.h-24 {
  height: 24px;
}

.opacity-70 {
  opacity: 0.7;
}

.opacity-50 {
  opacity: 0.5;
}
.Embed-container {
  width: 100%;
  height: 100%;
}

.Embed-container iframe {
  border: none;
}

.toast {
  border-left-width: 8px;
  border-left-style: solid;
  border-left-color: #db0d00;
  color: #595958;
}

.toast .toast-body {
  align-items: flex-start;
  gap: 1rem;
}

.toast .toast-body > div:first-child {
  margin: 0;
}

.toast .toast-body > div:last-child {
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #cacdcd;
}

:root {
  scrollbar-width: thin !important;
}

::-webkit-scrollbar {
  width: 15px !important;
  height: 14px !important;
  background-color: #ffffff !important;
}

::-webkit-scrollbar-thumb {
  background-color: #bdbdbc !important;
  border-radius: 10px !important;
  border: 4.5px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #8b8b8a !important;
}

::-webkit-scrollbar-corner {
  background-color: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,oCAAoC;AACtC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700;800&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap\");\r\n\r\nhtml:root {\r\n  --toastify-text-color-light: #595958;\r\n}\r\nbody {\r\n  word-break: break-word;\r\n}\r\n.icon-wrapper {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.w-20 {\r\n  width: 20px;\r\n}\r\n\r\n.w-24 {\r\n  width: 24px;\r\n}\r\n\r\n.h-24 {\r\n  height: 24px;\r\n}\r\n\r\n.opacity-70 {\r\n  opacity: 0.7;\r\n}\r\n\r\n.opacity-50 {\r\n  opacity: 0.5;\r\n}\r\n.Embed-container {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.Embed-container iframe {\r\n  border: none;\r\n}\r\n\r\n.toast {\r\n  border-left-width: 8px;\r\n  border-left-style: solid;\r\n  border-left-color: #db0d00;\r\n  color: #595958;\r\n}\r\n\r\n.toast .toast-body {\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n}\r\n\r\n.toast .toast-body > div:first-child {\r\n  margin: 0;\r\n}\r\n\r\n.toast .toast-body > div:last-child {\r\n  border-right-width: 1px;\r\n  border-right-style: solid;\r\n  border-right-color: #cacdcd;\r\n}\r\n\r\n:root {\r\n  scrollbar-width: thin !important;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 15px !important;\r\n  height: 14px !important;\r\n  background-color: #ffffff !important;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background-color: #bdbdbc !important;\r\n  border-radius: 10px !important;\r\n  border: 4.5px solid rgba(0, 0, 0, 0);\r\n  background-clip: padding-box;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background-color: #8b8b8a !important;\r\n}\r\n\r\n::-webkit-scrollbar-corner {\r\n  background-color: #ffffff !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
